import { render, staticRenderFns } from "./EmployeeSearchItem.vue?vue&type=template&id=53941917&scoped=true&"
import script from "./EmployeeSearchItem.vue?vue&type=script&lang=ts&"
export * from "./EmployeeSearchItem.vue?vue&type=script&lang=ts&"
import style0 from "./EmployeeSearchItem.vue?vue&type=style&index=0&id=53941917&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53941917",
  null
  
)

export default component.exports